<script>
import { apiORDSpost } from '../shared/api-functions'

export default {
    props: {
        nf: {
            type: Object,
            required: true
        },
        defaultTpEvento: { type: String, default: '' },
        defaultTpEventoAut: { type: String, default: '' },
        defaultNProtEvento: { type: String, default: '' }
    },
    data() {
        return {
            show: true,
            tpEventoSelecionado: '',
            camposCabecalho: {
                dhPagto: '',
                vPagto: 0,
                tpMeioPagto: '',
                dhPrevisaoEntrega: '',
                indAceitacao: 1,
                xJust: '',
                dhEntrega: '',
                nDoc: '',
                xNome: '',
                hashComprovante: '',
                dhHashComprovante: '',
                latGPS: '',
                longGPS: '',
                nProt: '',
                tpeventoaut: '',
                nprotevento: ''
            },
            itensEvento: [],
            erros: [],
            metadata: this.$store.getters.getEntities.metadata,
            listaEventosSaida: [
                { id: '112110', text: '112110 - Informacao de Efetivo Pagamento Integral' },
                { id: '112150', text: '112150 - Atualizacao da Data de Previsao de Entrega' },
                { id: '112120', text: '112120 - Importacao em ALC/ZFM nao convertida em isencao' },
                { id: '112130', text: '112130 - Perecimento/Perda durante o transporte pelo fornecedor (CIF)' },
                { id: '112140', text: '112140 - Fornecimento nao realizado com pagamento antecipado' },
                { id: '211110', text: '211110 - Solicitacao de Apropriacao de Credito Presumido' },
                { id: '110001', text: '110001 - Cancelamento de Evento' }
                // { id: '110130', text: '110130 - Comprovante de Entrega da NF-e' },
                // { id: '110192', text: '110192 - Insucesso na Entrega da NF-e' },
                // { id: '110160', text: '110160 - Conciliacao Financeira (ECONF)' },
                // { id: '110131', text: '110131 - Cancelamento do Comprovante de Entrega' }
            ],
            listaEventosEntrada: [
                { id: '211110', text: '211110 - Solicitacao de Apropriacao de Credito Presumido' },
                { id: '211130', text: '211130 - Imobilizacao de item' },
                { id: '211140', text: '211140 - Solicitacao de Apropriacao de Credito de Combustivel' },
                { id: '211150', text: '211150 - Solicitacao de Apropriacao de Credito (Bens/Serv. Atividade)' },
                { id: '211128', text: '211128 - Aceite de debito (Nota de Credito)' },
                { id: '211124', text: '211124 - Perecimento/Perda durante o transporte pelo adquirente (FOB)' }
                // { id: '211160', text: '211160 - Fornecimento nao realizado com pagamento antecipado' } // Removido/comentado conforme análise (código incorreto)
            ]
        }
    },
    computed: {
        listaEventos() {
            return this.nf.operacaonf === 'S' ? this.listaEventosSaida : this.listaEventosEntrada
        },
        exigeItens() {
            const eventosComItens = ['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124']
            return eventosComItens.includes(this.tpEventoSelecionado)
        }
    },
    watch: {
        tpEventoSelecionado() {
            this.erros = []
            this.inicializarItens()
        }
    },
    created() {
        this.inicializarItens()
        if (this.defaultTpEvento) {
            this.tpEventoSelecionado = this.defaultTpEvento;
            this.camposCabecalho.tpeventoaut = this.defaultTpEventoAut;
            this.camposCabecalho.nprotevento = this.defaultNProtEvento;
        }
    },
    methods: {
        inicializarItens() {
            if (this.nf.nfit) {
                this.itensEvento = this.nf.nfit.map(it => ({
                    nitem: it.itnf || it.nitem,
                    descricao: (it.item && it.item[0] ? it.item[0].descricao : '') ||
                               (it.nfitx && it.nfitx[0] ? it.nfitx[0].descricao : '') ||
                               it.descitem || it.xprod || it.descricao || 'Item ' + (it.itnf || it.nitem),
                    vbc: 0,
                    pcredpres: 0,
                    vcredpresibs: 0,
                    vcredprescbs: 0,
                    vibs: 0,
                    vcbs: 0,
                    qimob: it.qtd || it.qtde || 0,
                    qcomb: it.qtd || it.qtde || 0,
                    ucomb: it.uni || '',
                    cClassTrib: it.cclasstrib || '',
                    ccredpres: it.ccredpres || null,
                    qperecimento: it.qtd || it.qtde || 0,
                    uperecimento: it.uni || '',
                    vestornoibs: 0,
                    vestornocbs: 0,
                    qnaofornecida: it.qtd || it.qtde || 0,
                    unaofornecida: it.uni || ''
                }))
            }
        },
        async handleEnviar() {
            this.erros = []

            if (!this.tpEventoSelecionado) {
                this.erros.push('Selecione um tipo de evento.')
                return
            }

            // Validações básicas por evento
            if (this.tpEventoSelecionado === '110001') {
                if (!this.camposCabecalho.tpeventoaut) {
                    this.erros.push('O código do evento original a ser cancelado é obrigatório.')
                }
                if (!this.camposCabecalho.nprotevento) {
                    this.erros.push('O número do protocolo do evento original é obrigatório.')
                }
                if (!this.camposCabecalho.xJust) {
                    this.erros.push('A justificativa do cancelamento é obrigatória.')
                } else if (this.camposCabecalho.xJust.length < 15) {
                    this.erros.push('A justificativa do cancelamento deve ter pelo menos 15 caracteres.')
                }
            }

            /*
            if (this.tpEventoSelecionado === '110192') {
                if (!this.camposCabecalho.dhPagto) this.erros.push('Data da tentativa é obrigatória.')
                if (!this.camposCabecalho.tpMeioPagto) this.erros.push('Motivo do insucesso é obrigatório.')
                if (!this.camposCabecalho.xJust && this.camposCabecalho.tpMeioPagto === '4') this.erros.push('Justificativa é obrigatória para o motivo Outros.')
                if (!this.camposCabecalho.hashComprovante) this.erros.push('O envio da foto da tentativa infrutífera é obrigatório para gerar o hash do insucesso.')
            }

            if (this.tpEventoSelecionado === '110160') {
                if (this.camposCabecalho.vPagto <= 0) this.erros.push('Valor do pagamento deve ser maior que zero.')
                if (!this.camposCabecalho.tpMeioPagto) this.erros.push('Meio de pagamento é obrigatório.')
            }

            if (this.tpEventoSelecionado === '110131') {
                if (!this.camposCabecalho.nProt) this.erros.push('O protocolo do comprovante de entrega é obrigatório.')
            }

            if (this.tpEventoSelecionado === '110130') {
                if (!this.camposCabecalho.dhEntrega) this.erros.push('Data e hora da entrega é obrigatória.')
                if (!this.camposCabecalho.nDoc) this.erros.push('Documento do recebedor (CPF/CNPJ) é obrigatório.')
                if (!this.camposCabecalho.xNome) this.erros.push('Nome do recebedor é obrigatório.')
                if (!this.camposCabecalho.hashComprovante) this.erros.push('O envio da foto do canhoto assinado é obrigatório para gerar o hash do comprovante.')
            }
            */


            if (this.tpEventoSelecionado === '211110') {
                this.itensEvento.forEach(it => {
                    if ((it.vibs > 0 || it.vcbs > 0 || it.vbc > 0) && !it.ccredpres) {
                        this.erros.push('Item ' + it.nitem + ': Código do Crédito Presumido (Cód. Créd. Pres.) é obrigatório quando há valores informados.')
                    }
                })
            }

            if (this.erros.length > 0) return

            const tipoCert = this.$certificadoCheck ? this.$certificadoCheck(this.nf.codfil) : ''
            const isA3 = tipoCert === 'A3'

            const payload = {
                codnf: this.nf.codnf,
                codfil: this.nf.codfil,
                tpeventonfe: this.tpEventoSelecionado,
                a3: isA3,
                cabecalho: this.camposCabecalho,
                itens: this.exigeItens ? this.itensEvento.filter(it =>
                    it.vibs > 0 || it.vcbs > 0 || it.vbc > 0 || it.qimob > 0 || it.qcomb > 0 ||
                    it.qperecimento > 0 || it.qnaofornecida > 0 || it.vestornoibs > 0 || it.vestornocbs > 0
                ) : []
            }

            if (this.exigeItens && payload.itens.length === 0) {
                this.erros.push('Preencha os dados de ao menos um item para este evento.')
                return
            }

            try {
                const response = await apiORDSpost(this.$store, 'invoice/evento/', payload, 'post')
                if (response.status === 'success') {
                    if (isA3) {
                        const extraParams = '&tpevento=' + this.tpEventoSelecionado
                        this.$executaExtensaoChromeA3(this.nf.codnf, 'eventortc', (a3Resp) => {
                            if (a3Resp && a3Resp.status === 'success') {
                                this.$erpToastSuccess('Evento autorizado com sucesso')
                                this.$emit('success')
                                this.handleClose()
                            } else {
                                const msg = a3Resp ? a3Resp.message : 'Erro ao processar evento no módulo A3'
                                this.erros = [msg]
                                if (this.$erpToastError) {
                                    this.$erpToastError(msg)
                                }
                            }
                        }, extraParams)
                        return
                    }

                    this.$erpToastSuccess('Evento enviado com sucesso')
                    this.$emit('success')
                    this.handleClose()
                } else {
                    this.erros = response.errmessages || [response.message]
                }
            } catch (error) {
                this.erros.push('Erro ao processar requisição: ' + error.message)
            }
        },
        async handleUploadCanhoto(event) {
            const file = event.target.files[0]
            if (!file) return

            const reader = new FileReader()
            reader.onload = async (e) => {
                const base64Data = e.target.result.split(',')[1] // Obtém apenas a string base64 pura
                const rawString = (this.nf.chavenf || this.nf.chave || '') + base64Data

                try {
                    // Computa SHA-1 usando a API Web Crypto nativa do navegador
                    const encoder = new TextEncoder()
                    const data = encoder.encode(rawString)
                    const hashBuffer = await window.crypto.subtle.digest('SHA-1', data)

                    // Converte o hash binário resultante para string e então para Base64
                    const hashArray = Array.from(new Uint8Array(hashBuffer))
                    const hashString = hashArray.map(b => String.fromCharCode(b)).join('')
                    this.camposCabecalho.hashComprovante = window.btoa(hashString)

                    // Define dhHashComprovante com a data/hora local atual no formato ISO
                    const localDate = new Date();
                    const offsetMs = localDate.getTimezoneOffset() * 60 * 1000;
                    this.camposCabecalho.dhHashComprovante = new Date(localDate.getTime() - offsetMs).toISOString().substring(0, 19);
                } catch (err) {
                    this.erros.push('Erro ao gerar hash do comprovante: ' + err.message)
                }
            }
            reader.readAsDataURL(file)
        },
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>

<template>
    <div class="nb-modal-mask">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="def-title">Eventos NF-e - {{ nf.nf }} / {{ nf.serie }}</h4>
                    <button type="button" class="close" @click="handleClose">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="max-height: 70vh; overflow-y: auto">

                    <div v-if="erros.length > 0" class="alert alert-danger">
                        <ul>
                            <li v-for="(err, idx) in erros" :key="idx">{{ err }}</li>
                        </ul>
                    </div>

                    <div class="row">
                        <form-field v-model="tpEventoSelecionado" type="select" col="12" label="Tipo de Evento"
                            :select-options="listaEventos" :disabled="!!defaultTpEvento"></form-field>
                    </div>

                    <div class="row" v-if="tpEventoSelecionado === '110001'">
                      <form-field v-model="camposCabecalho.tpeventoaut" type="text" col="4" label="Evento Original" :disabled="!!defaultTpEventoAut"></form-field>
                      <form-field v-model="camposCabecalho.nprotevento" type="text" col="8" label="Protocolo Original" :disabled="!!defaultNProtEvento"></form-field>
                      <form-field v-model="camposCabecalho.xJust" type="text" col="12" label="Justificativa do Cancelamento" placeholder="Digite a justificativa (mínimo de 15 caracteres)"></form-field>
                    </div>

                    <hr v-if="tpEventoSelecionado">

                    <!-- Campos de Cabeçalho Dinâmicos -->

                    <div class="row" v-if="tpEventoSelecionado === '112150'">
                        <form-field v-model="camposCabecalho.dhPrevisaoEntrega" type="date" col="12" label="Nova Previsão de Entrega"></form-field>
                    </div>

                    <!--
                    <div class="row" v-if="tpEventoSelecionado === '110192'">
                        <form-field v-model="camposCabecalho.dhPagto" type="date" col="4" label="Data da Tentativa"></form-field>
                        <form-field v-model="camposCabecalho.tpMeioPagto" type="select" col="4" label="Motivo do Insucesso"
                            :select-options="[{id: '1', text: '1 - Recebedor não encontrado'}, {id: '2', text: '2 - Recusa de recebimento'}, {id: '3', text: '3 - Endereço não localizado'}, {id: '4', text: '4 - Outros'}]"></form-field>
                        <form-field v-model="camposCabecalho.xJust" type="text" col="4" label="Justificativa"></form-field>
                        <form-field v-model="camposCabecalho.latGPS" type="text" col="6" label="Latitude GPS (Opcional)"></form-field>
                        <form-field v-model="camposCabecalho.longGPS" type="text" col="6" label="Longitude GPS (Opcional)"></form-field>
                        <div class="col-12 mt-3">
                            <label class="font-weight-bold">Foto da Tentativa Infrutífera (Upload Obrigatório):</label>
                            <input type="file" class="form-control-file" accept="image/*" @change="handleUploadCanhoto">
                            <div v-if="camposCabecalho.hashComprovante" class="alert alert-success mt-2 p-2 small">
                                <i class="fa fa-check-circle"></i> Hash gerado com sucesso: <strong>{{ camposCabecalho.hashComprovante }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="tpEventoSelecionado === '110160'">
                        <form-field v-model="camposCabecalho.vPagto" type="value" col="6" label="Valor do Pagamento" :precision="2"></form-field>
                        <form-field v-model="camposCabecalho.tpMeioPagto" type="select" col="6" label="Meio de Pagamento"
                            :select-options="[{id: '01', text: '01 - Dinheiro'}, {id: '02', text: '02 - Cheque'}, {id: '03', text: '03 - Cartão de Crédito'}, {id: '04', text: '04 - Cartão de Débito'}, {id: '15', text: '15 - Boleto Bancário'}, {id: '17', text: '17 - Pix'}, {id: '99', text: '99 - Outros'}]"></form-field>
                    </div>

                    <div class="row" v-if="tpEventoSelecionado === '110131'">
                        <form-field v-model="camposCabecalho.nProt" type="text" col="12" label="Protocolo do Comprovante de Entrega a Cancelar"></form-field>
                    </div>
                    -->

                    <div class="row" v-if="tpEventoSelecionado === '211128'">
                        <form-field v-model="camposCabecalho.indAceitacao" type="select" col="12" label="Aceite"
                            :select-options="[{id: 1, text: 'Sim (Aceitar)'}, {id: 0, text: 'Não (Recusar)'}]"></form-field>
                    </div>

                    <!--
                    <div class="row" v-if="tpEventoSelecionado === '110130'">
                        <form-field v-model="camposCabecalho.dhEntrega" type="date" col="4" label="Data da Entrega"></form-field>
                        <form-field v-model="camposCabecalho.nDoc" type="text" col="4" label="Doc. Recebedor (CNPJ / CPF)"></form-field>
                        <form-field v-model="camposCabecalho.xNome" type="text" col="4" label="Nome do Recebedor"></form-field>
                        <form-field v-model="camposCabecalho.latGPS" type="text" col="6" label="Latitude GPS (Opcional)"></form-field>
                        <form-field v-model="camposCabecalho.longGPS" type="text" col="6" label="Longitude GPS (Opcional)"></form-field>
                        <div class="col-12 mt-3">
                            <label class="font-weight-bold">Foto do Canhoto Assinado (Upload Obrigatório):</label>
                            <input type="file" class="form-control-file" accept="image/*" @change="handleUploadCanhoto">
                            <div v-if="camposCabecalho.hashComprovante" class="alert alert-success mt-2 p-2 small">
                                <i class="fa fa-check-circle"></i> Hash gerado com sucesso: <strong>{{ camposCabecalho.hashComprovante }}</strong>
                            </div>
                        </div>
                    </div>
                    -->

                    <!-- Grade de Itens -->
                    <div v-if="exigeItens" class="mt-4">
                        <label-title title="Itens da Nota Fiscal" icon="fa-list"></label-title>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Produto</th>
                                        <th v-if="tpEventoSelecionado === '211110'">Base Calc.</th>
                                        <th v-if="tpEventoSelecionado === '211110'">% Cred.</th>
                                        <th v-if="tpEventoSelecionado === '211110'">Cód. Créd. Pres.</th>
                                        <th v-if="['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(tpEventoSelecionado)">Vlr IBS</th>
                                        <th v-if="['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(tpEventoSelecionado)">Vlr CBS</th>
                                        <th v-if="tpEventoSelecionado === '211130'">Qtd Imob.</th>
                                        <th v-if="tpEventoSelecionado === '211140'">Qtd Comb.</th>
                                        <th v-if="tpEventoSelecionado === '112120'">Qtd Consumo</th>
                                        <th v-if="tpEventoSelecionado === '112120'">Unid. Consumo</th>
                                        <th v-if="['112130', '211124'].includes(tpEventoSelecionado)">Qtd Perecida</th>
                                        <th v-if="['112130', '211124'].includes(tpEventoSelecionado)">Unid. Perecida</th>
                                        <th v-if="tpEventoSelecionado === '112130'">IBS Estorno</th>
                                        <th v-if="tpEventoSelecionado === '112130'">CBS Estorno</th>
                                        <th v-if="tpEventoSelecionado === '112140'">Qtd Não Forn.</th>
                                        <th v-if="tpEventoSelecionado === '112140'">Unid. Não Forn.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(it, idx) in itensEvento" :key="idx">
                                        <td>{{ it.nitem }}</td>
                                        <td>{{ it.descricao }}</td>
                                        <td v-if="tpEventoSelecionado === '211110'">
                                            <form-field v-model="it.vbc" type="value" col="" :nolabel="true" :precision="2"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '211110'">
                                            <form-field v-model="it.pcredpres" type="value" col="" :nolabel="true" :precision="4"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '211110'">
                                            <form-field v-model="it.ccredpres" type="select" col="" :nolabel="true" :metadata="metadata.nfit.ccredpres"></form-field>
                                        </td>
                                        <td v-if="['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(tpEventoSelecionado)">
                                            <form-field v-model="it.vibs" type="value" col="" :nolabel="true" :precision="2"></form-field>
                                        </td>
                                        <td v-if="['211110', '211130', '211140', '211150', '112120', '112130', '112140', '211124'].includes(tpEventoSelecionado)">
                                            <form-field v-model="it.vcbs" type="value" col="" :nolabel="true" :precision="2"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '211130'">
                                            <form-field v-model="it.qimob" type="value" col="" :nolabel="true" :precision="4"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '211140'">
                                            <form-field v-model="it.qcomb" type="value" col="" :nolabel="true" :precision="4"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '112120'">
                                            <form-field v-model="it.qcomb" type="value" col="" :nolabel="true" :precision="4"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '112120'">
                                            <form-field v-model="it.ucomb" type="text" col="" :nolabel="true" placeholder="Ex: UN"></form-field>
                                        </td>
                                        <td v-if="['112130', '211124'].includes(tpEventoSelecionado)">
                                            <form-field v-model="it.qperecimento" type="value" col="" :nolabel="true" :precision="4"></form-field>
                                        </td>
                                        <td v-if="['112130', '211124'].includes(tpEventoSelecionado)">
                                            <form-field v-model="it.uperecimento" type="text" col="" :nolabel="true" placeholder="Ex: UN"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '112130'">
                                            <form-field v-model="it.vestornoibs" type="value" col="" :nolabel="true" :precision="2"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '112130'">
                                            <form-field v-model="it.vestornocbs" type="value" col="" :nolabel="true" :precision="2"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '112140'">
                                            <form-field v-model="it.qnaofornecida" type="value" col="" :nolabel="true" :precision="4"></form-field>
                                        </td>
                                        <td v-if="tpEventoSelecionado === '112140'">
                                            <form-field v-model="it.unaofornecida" type="text" col="" :nolabel="true" placeholder="Ex: UN"></form-field>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <v-button label="Enviar Evento NF-e" icon="fa-paper-plane" :nb-btdef="true" @click="handleEnviar"></v-button>
                    <v-button label="Cancelar" icon="fa-times" @click="handleClose"></v-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.nb-modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-dialog {
    width: 90%;
    max-width: 90% !important;
    min-width: 320px;
}
.modal-content {
    min-height: 300px;
}
@media (min-width: 768px) {
    .modal-dialog {
        min-width: 600px;
    }
    .modal-content {
        min-height: 400px;
    }
}
@media (min-width: 1200px) {
    .modal-dialog {
        min-width: 900px;
    }
    .modal-content {
        min-height: 450px;
    }
}
</style>



// WEBPACK FOOTER //
// src/forms/nfe-eventos-form.vue